import React from "react";
import { connect } from "react-redux";

import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import FrequencyPreviewConfig from "@app/component/frequency/type/FrequencyPreviewConfig";
import { getFrequencyModalConfig } from "@app/store/frequency";
import { RootState } from "@app/store/rootReducer";

import styles from "./ProTip.module.scss";

interface Props {
  config: FrequencyPreviewConfig;
}

const ProTip = ({ config }: Props) => {
  const intl = useIntl();
  const { isGroupFrequencyConfigured } = config;

  if (isGroupFrequencyConfigured) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} />
        <span>
          {intl.formatMessage({
            id: "frequency.frequencyModal.frequencies.proTip",
            defaultMessage: "Pro Tip",
            description: "frequency component - frequency modal - frequencies - pro tip",
          })}
        </span>
      </div>
      <div className={styles.subTitle}>
        {intl.formatMessage({
          id: "frequency.frequencyModal.frequencies.proTip.subTitle",
          defaultMessage:
            "Additional frequencies can be set by placing this record within a Group that has an active frequency.",
          description: "frequency component - frequency modal - frequencies - pro tip - sub title",
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  config: getFrequencyModalConfig(state),
});

export default connect(mapStateToProps)(ProTip);
